// Keeps the lessons a teacher has already loaded readable offline.
// Scoped per user and cleared on sign-out.

import { readJson, remove, writeJson } from "./storage";

const key = (userId) => `content:${userId}`;

const read = (userId) => readJson(key(userId), { lessons: null, blocks: {} });

export const getCachedLessons = (userId) => read(userId).lessons;

export const cacheLessons = (userId, lessons) =>
  writeJson(key(userId), { ...read(userId), lessons });

export const getCachedBlocks = (userId, lessonId) =>
  read(userId).blocks[lessonId] || null;

// Only keeps blocks for lessons that are still in the teacher's list.
export const cacheBlocks = (userId, lessonId, blocks) => {
  const cached = read(userId);
  const known = new Set((cached.lessons || []).map((lesson) => lesson.id));
  const kept = Object.fromEntries(
    Object.entries(cached.blocks).filter(([id]) => known.has(id))
  );
  writeJson(key(userId), {
    ...cached,
    blocks: { ...kept, [lessonId]: blocks },
  });
};

export const clearContent = (userId) => remove(key(userId));
